<template>
  <section class="d-flex mt-md-5">
    <div class="container">
      <div class="row">
        <div class="col-12 text-center">
          <h3>
            Votre
            <span class="highlight highlight-green-500">
              déclaration de sinistre
            </span>
            <span> a bien été envoyée </span>
          </h3>
        </div>
        <div class="col-12 text-center my-4">
          <img
            class="img-fluid"
            style="height: 250px"
            :src="aws + 'unicorn-plane.png'"
          >
        </div>
        <div class="col-12 text-center">
          Votre déclaration de sinistre a bien été transmise.
          Nous reviendrons vers vous au plus vite !
        </div>
        <div class="col-12 text-center my-3">
          <v-loader
            title="Retour à l'historique"
            icon="arrow-white-right"
            :next="() => $router.push('/client/claim')"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'ClaimConfirmation',
  computed: {
    aws: () => `${import.meta.env.VITE_AWS_STATIC}/common/png/`,
  },
};
</script>
<style scoped>
.highlight + span {
  position: relative;
}
</style>
